import React from 'react';
import { Button, Text } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';
import AttachmentTable from './AttachmentTable';
import { Attachment } from '../../../../../contexts/SettingsContext';

const AttachmentPreview: React.FC<{
  attachments: (string | Attachment)[];
  styles: any;
  onRemove: (i: number) => void;
  onClear: () => void;
}> = ({ attachments, styles, onRemove, onClear }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.attachmentPreview}>
      <div className={styles.attachmentHeader}>
        <Text size={200} weight="semibold">
          {t("chat.attachedRowsCount", { count: attachments.length })}
        </Text>

        <Button 
          size="small" 
          appearance="subtle" 
          onClick={onClear}
          disabled={attachments.length === 0}
        >
          {t("chat.clearAll")}
        </Button>
      </div>

      {attachments.map((attachment, index) => (
        <div key={index} className={styles.attachmentItem}>
          <AttachmentTable 
            attachment={attachment}
            tableIndex={index}
            styles={styles}
            onRemove={() => onRemove(index)}
          />
        </div>
      ))}
    </div>
  );
};

export default AttachmentPreview;